import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Template } from '../models/template';
import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class EmailService {
    private readonly baseUrl = environment.api + '/mail';

    public all = async (): Promise<Template[]> => {
        const data = await firstValueFrom(this.http.get<Template[]>(`${this.baseUrl}/templates`));
        return data;
    }
    public async send(receiver: string, subject: string, content: string) {
        const data = { receiver, subject, content };
        await firstValueFrom(this.http.post<boolean>(`${this.baseUrl}/send`, data));
    }
    public async substituteTemplate(id: string, content: string, variables: Record<string, string>, conditions: Record<string, number | null>): Promise<string> {
        return await firstValueFrom(this.http.post<string>(`${this.baseUrl}/substitute-template`, {id, content, variables, conditions }));
    }
    constructor(
        private http: HttpClient
    ) { }
}
